module.exports = __webpack_public_path__ + "static/media/old-lady.c6d4fe49.png";